import React, { useState } from 'react';
import { CustomLoadingIcon } from '../../../../supplementary_components/loading_icon';
import { sendRequest, API_ROOT } from '../../../../supplementary_components/requests';

export const MarkAsReadyToInvoiceButton = ({loadId, setDataMethod})=>{
    
    
    const [loading, setLoading] = useState(false);
    return <div className="non-selectable" style={{
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        backgroundColor: !loading ? 'var(--main-color)' : "rgba(var(--successGreenRGB), 0.5)",
        textAlign:"center",
        padding:'0.7rem 0',
        borderRadius:"0.4rem",
        fontWeight:"700",
        fontSize:"1.1rem",
        color:"white",
        margin:"-0.6rem 0 0.6rem 0",
        cursor:"pointer"
    }}
    onClick={(e)=>{
        try {
            if(!loading){
                setLoading(true);
                sendRequest("POST", API_ROOT+"loads/markAsReadyForInvoice?loadId="+loadId, null, (res)=>{
                    setDataMethod(res)
                }, ()=>{
                    setLoading(false);
                })
            }
        } catch (error) {
            
        }
    }}
>{`Ready For Invoice`}{loading ? <CustomLoadingIcon height="1rem" strokeColor="white" marginLeft={"0.5rem"} />:null}</div>
}